<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 18:40:22
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-29 10:19:29
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/myActivities/list/components/tableCell/activityCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex flex-align-center">
		<div class="ellipsis fz-12" style="max-width: 260px">{{ row.activity_name }}</div>
		<el-tooltip placement="top">
			<div slot="content">
				<div
					>活动ID {{ row.third_activity_id }}<i @click="$copy(row.third_activity_id)" class="fz-12 ml-8 el-icon-copy-document cursor-pointer"></i
				></div>
			</div>
			<div class="tag">ID</div>
		</el-tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
